<template>
    <div class="signature-wrapper">
        <canvas 
            :id="'signature_'+_uid" 
            class="signature-canvas" 
            width="720" 
            height="300"
        />
        <button 
            type="button" 
            class="btn btn-small btn-light" 
            @click="clear()"
        >
            Clear
        </button>
    </div>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
    data: function() {
        return {
            canvas: null,
            pad: null
        };
    },
    mounted: function() {
        this.canvas = document.getElementById("signature_" + this._uid);
        this.pad = new SignaturePad(this.canvas);
    },
    methods: {
        clear: function() {
            this.pad.clear();
        },
        toPng: function() {
            return this.pad.toDataURL();
        },
        resizeCanvas: function() {
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            const canvas = this.canvas;
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
            this.pad.clear();
        },
        isEmpty: function() {
            return this.pad.isEmpty();
        },
    }
};
</script>

<style lang="scss" scoped>
.signature-wrapper {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  overflow: hidden;
  max-height: 320px;

  .signature-canvas {
    border-bottom: 1px dashed #000;
    margin-bottom: 1rem;
    width: 100%;
  }

  .btn {
    display: block;
    float: none;
    width: auto;
    position: absolute;
    bottom: 0;
    right: 15px;
  }
}
</style>





// WEBPACK FOOTER //
// resources/assets/js/components/SignatureComponent.vue